import React from 'react'
import * as route from 'constants/routes'
import SiteLink from 'components/Common/SiteLink'

const Footer: React.FC = () => {
    return (
        <footer className="py-6" style={{ backgroundColor: `#0071c0` }}>
            <div className="container mx-auto flex flex-col items-center gap-4">
                {/* Center Logo */}
                <SiteLink to={route.INDEX} className="">
                    <img
                        src="/assets/Logo-removebg-preview.png"
                        alt="Grays 10k Logo"
                        className="h-16 w-auto object-contain"
                    />
                </SiteLink>

                {/* Contact & Social */}
                <div className="flex flex-col items-center gap-4 text-center">
                    {/* Facebook */}
                    <p>
                        <a
                            href="https://www.facebook.com/profile.php?id=61572891501145"
                            className="flex items-center gap-2 hover:text-blue-200"
                            target="_blank"
                            rel="noreferrer">
                            <svg
                                className="h-5 w-5"
                                fill="currentColor"
                                viewBox="0 0 24 24"
                                aria-hidden="true">
                                <path
                                    fillRule="evenodd"
                                    d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                                    clipRule="evenodd"></path>
                            </svg>
                        </a>
                    </p>
                    {/* Email */}
                    <p>
                        <a href="mailto:graysrun@outlook.com" className="hover:text-blue-200">
                            graysrun@outlook.com
                        </a>
                    </p>
                    {/* <div className="mb-6">
                        <span className="text-sm sm:text-center">
                            © 2025 Grays Run . All Rights Reserved.
                        </span>
                    </div> */}
                </div>
            </div>
        </footer>
    )
}

export default Footer
